import { Dc_Text_Glossar_Unsynced } from "@op/sf-op/components/Dc_Text_Glossar_Unsynced";
import type { GlossaryItemMarkProps } from "../../../../../renderer/RichTextRenderer/marks/GlossaryItemMark";
import { useMemo } from "react";
import { useContent } from "@op/utils/src/hooks";
import { makeGlossaryItemDefinitionId, makeGlossaryItemId } from "@op/utils";

const GlossaryItemMark = ({ uniqueId, children }: GlossaryItemMarkProps) => {
  const { glossaryItems } = useContent();

  const glossaryItem = useMemo(() => {
    return glossaryItems.find((g) => g.uniqueId === uniqueId);
  }, [glossaryItems, uniqueId]);

  if (!glossaryItem) return null;
  return (
    <a href={`#${makeGlossaryItemDefinitionId(glossaryItem.id)}`}>
      <Dc_Text_Glossar_Unsynced
        id={makeGlossaryItemId(glossaryItem.id)}
        text={children}
      />
    </a>
  );
};

export default GlossaryItemMark;
